<template>
    <div>
        <nav class="navbar-light text-left text-smallest font-weight-bold shadow side-nav mr-2"
             style="width: 115px;">
            <ul class="nav flex-column h-100p text-left">
                <li class="nav-item">
                    <router-link
                            :to="{name: 'SeaExperience'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('SeaExperience')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Sea Experience
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'ExternalExperience'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('ExternalExperience')}"
                            role="tab"
                            data-toggle="list"
                    >
                        External Experience
                    </router-link>
                </li>
            </ul>
        </nav>
        <router-view></router-view>
    </div>

</template>

<script>

    import { vueAppMixin } from "@/mixins/vueAppMixin";

    export default {
        name: "WorkExperience",
        mixins: [ vueAppMixin ],

    }
</script>

<style scoped>
    .nav-link.active, .nav-link:hover {
        background-color: #e87c87;
        color: white !important;
    }
</style>
